// extracted by mini-css-extract-plugin
export default {"dashboardCol":"DashboardCol_dashboardCol__g1ewo"};